export default __webpack_public_path__ + "static/media/melania-close.265a55cc.jpg";